/* The detail surface.
 *
 * Two modes, as before: the rail that introduces the path, or the open chapter.
 * `data-mode` is what the CSS keys off, so the mode is derived here and nowhere
 * else.
 */
import { useTranslation } from 'react-i18next';
import { byId } from '../../engine/progress';
import { useApp } from '../../state/AppProvider';
import { Chapter } from './Chapter';
import { Overview } from './Overview';
import { ResetConfirm } from './ResetConfirm';

export function Panel() {
  const { t } = useTranslation();
  const { sel, resetConfirm } = useApp();
  const node = sel ? byId(sel) : null;

  return (
    <aside
      className="panel"
      id="panel"
      data-mode={resetConfirm.open || !node ? 'overview' : 'chapter'}
      data-od-id="panel"
      aria-label={t('panelLabel')}
    >
      {resetConfirm.open ? <ResetConfirm /> : node ? <Chapter node={node} /> : <Overview />}
    </aside>
  );
}
